"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ABBY_FEATUREFLAGS: () => ABBY_FEATUREFLAGS,
  ABBY_REMOTECONFIGS: () => ABBY_REMOTECONFIGS
});
module.exports = __toCommonJS(src_exports);

// src/feature-flags.ts
var ABBY_FEATUREFLAGS = [
  "showProductPageAlsoForUnreleasedCategory",
  "showNewFairCategories",
  "useJsonLdQuery",
  "useAssociatedProductsQueryV2",
  "useAssociatedModelsWithProductsByIdsV2",
  "useNewHeader",
  "useNewHeaderLanguageSwitcher",
  "showRollers",
  "showEChainStrainReliefs",
  "showEchainSmartIotSolutions",
  "showEChainInteriorSeparators",
  "showEChainHorizontalShelves",
  "showEChainMountingBrackets",
  "showEChain",
  "showEChainSelectedModelsOnly",
  "showMotorFlanges",
  "showConnectingCables",
  "showMotors",
  "showDriveTechnology",
  "showDrylinLeadScrews",
  "showDrylinTRailGuide",
  "showDrylinLinearTechnology",
  "showVATOnBallBearingsDeOnly",
  "showEchainLinearMovement",
  "showCadSearchButton",
  "showOverstockSale",
  "showTribotape",
  "show3dPrinting",
  "useRefactoredVerfahrwegBehavior",
  "enableOverstockSaleOnDemandPrices",
  "useEvergage",
  "useCatalogDataApi",
  "show3dMovement",
  "showBarStocks",
  "showLowCostAutomation",
  "ibh_useIcn",
  "ibh_useFilterReleaseLocales",
  "ibh_useAddToCartMultiSelection",
  "ibh_useMultiFileDownload"
];

// src/remote-configs.ts
var ABBY_REMOTECONFIGS = {
  showNewHeaderLocalesConfig: "String",
  echainSelectedModelIds: "String",
  ignoredMenuCategories: "String",
  abTestProductOverviewListOrGridUntil: "String",
  newMyigusLocalesConfig: "String",
  chainflexOverstockSaleLocales: "JSON"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ABBY_FEATUREFLAGS,
  ABBY_REMOTECONFIGS
});
